import { Component, Input, Output,  AfterViewInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'cli-star-rating',
  template: `<span class="cli-star" *ngIf="starReadonly">
  <i  *ngFor="let i of star" class="fa" aria-hidden="true" 
  [ngClass]="{'fa-star-o':i == 'false','fa-star' :i == 'full', 'fa-star-half-o' : i == 'half'}"></i>

</span>
<span title="{{rateText}}" class="cli-star cli-star-hover"  *ngIf="!starReadonly">
  <i  *ngFor="let i of star;let ix = index" class="fa" aria-hidden="true" 
  (click) = "rateIt(ix)" (mouseover)="addHoverClass(ix)" (mouseleave)="resetHover()"
  [ngClass]="{'fa-star-o':i == 'false','fa-star' :i == 'full' || hoverStar[ix], 
    'fa-star-half-o' : i == 'half'}"></i>

</span>`,
  styles: [`.cli-star{display:inline-block;}
.cli-star-hover i:hover~i{opacity:0.3;}
.cli-star-hover:hover .fa-star-o.fa-star:before,
.cli-star-hover:hover .fa-star-half-o.fa-star:before{content:'\\F005';}`]
})
export class AngularcliStarRatingComponent implements AfterViewInit {

  @Input('rating') rating : Number = 0;
  @Input('starReadonly') starReadonly : Boolean = true;
  @Output() onStarRate  = new EventEmitter<any>();
  @Input('starRateText') rateText : any = "Click to Rate."

  star :  Array<string> =["false","false","false","false","false"];
  hoverStar : Array<Boolean> = [false,false,false,false,false];

  constructor() { }

  ngAfterViewInit(){
    this.checkRating();
  }
  addHoverClass(index : Number){
    this.hoverStar = [false,false,false,false,false];
    for(let p=0;p<5;p++){
      if(p <= index)this.hoverStar[p] = true;
    }
  }
  resetHover(){
    this.hoverStar = [false,false,false,false,false];
  }
  checkRating(){
    if(this.rating <= 5 && this.rating >= 0){
      if(this.rating > 0)this.loadStar(this.rating);
    }else{
      console.log("Rating should be between 0 and 5");
    }
  }
  resetStar(){
    this.star = ["false","false","false","false","false"];
  }
  rateIt(num : any){
    this.rating = num;
    this.resetStar();
    this.fillStar(this.rating);
    let value = num + 1;
    this.onStarRate.emit([value]);
   
  }

  fillStar(num : Number){
    for(let x= 0; x< 5;x++){
      if(num >=x)this.star[x] = "full";
    }
  }
  loadStar(num : any){
    let halfStar = num%1 != 0 ? true : false;// check number is round or double
    let halfNum = Math.floor(num);//
    for(let x= 0; x< 5;x++){
      if(x < num)this.star[x] = "full";
      if(halfStar && halfNum == x)this.star[x] = "half";
    }
  }

}
